/**
 * Copyright (c) 2025-present, NDLA.
 *
 * This source code is licensed under the GPLv3 license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */

// N.B! AUTOGENERATED FILE. DO NOT EDIT
// Source: Feide
// License: CC-BY 4.0
import type { JSX } from "react";
import { Icon, type Props } from "../Icon";
export const Feide = (props: Props): JSX.Element => (
  <Icon viewBox="-7 -2 45 45" {...props}>
    <path d="M28 20.3h4.2v10.2H28zm-9.8 3H14v11.5H4.2V20.3H0V39h32.2v-4.2h-14z" />
    <circle cx="16.1" cy="16.5" r="2.5" />
    <path d="M16.1 4.2A11.9 11.9 0 0 1 28 16.1h4.3a16.1 16.1 0 0 0-32.3 0h4.3A11.9 11.9 0 0 1 16 4.2Z" />
  </Icon>
);
